import { Flex, Th } from "@chakra-ui/react";
import { DeveloperModeIcon } from "./developer-mode-icon";
import { useTenant } from "modules/tenant/providers/tenant-provider";

interface ThDeveloperModeProps {
  children: React.ReactNode;
}

export function ThDeveloperMode({ children }: ThDeveloperModeProps) {
  const { developerMode } = useTenant();

  if (!developerMode) return null;

  return (
    <Th>
      <Flex alignItems="center" gap={2}>
        {children}
        <DeveloperModeIcon />
      </Flex>
    </Th>
  );
}
